export default "__VITE_ASSET__e5999532__"